import { Stack } from '@mui/material';
import React from 'react';

import { ChevronDownIcon } from '@/shared/assets/icons/chevron-down-icon';
import { ChevronUpIcon } from '@/shared/assets/icons/chevron-up-icon';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';
import {
  StyledAvatar,
  StyledButton,
} from '@/shared/features/header/components/user-menu-button/user-menu-button.styled';
import { TUserMenuButton } from '@/shared/features/header/components/user-menu-button/user-menu-button.types';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';
import { getAvatarLabel } from '@/shared/utils/avatar';

export const UserMenuButton: React.FC<TUserMenuButton> = (props) => {
  const user = useAppSelector(selectUser);
  const email = user?.attributes?.email ?? '';

  const getFullName = () => {
    if (!user?.attributes?.name && !user?.attributes?.family_name) {
      return null;
    }
    return `${user?.attributes?.name} ${user?.attributes?.family_name}`;
  };

  return (
    <StyledButton variant="secondary" size="large" {...props}>
      <StyledAvatar>{getAvatarLabel(getFullName() ?? email)}</StyledAvatar>
      <Stack
        gap="2px"
        alignItems="flex-start"
        width="100%"
        flex={1}
        minWidth={0}
      >
        <TruncatedText
          variant="p4"
          color="textPrimary"
          text={getFullName() ?? email}
          maxLength={20}
          noWrap
        />
        {!!getFullName() && (
          <TruncatedText
            variant="p10"
            color="textSecondary"
            text={email}
            maxLength={22}
          />
        )}
      </Stack>
      {props?.clicked ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </StyledButton>
  );
};
